import axios from '@/api/axios'
import store from '@/store'
import _, { result } from 'lodash'

// 토큰 가지고 오기
const getToken = async (param, result) => {
  let finalData = {
    accessToken: '',
    user: {
      id: '',
      name: ''
    }
  }

  const options = {
    method: 'POST',
    url: '/member/login',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: {
      type: param.type,
      id: param.id,
      pw: param.pw
    }
  }

  try {
    await axios(options).then((response) => {
      if (response.data.code === 100) {
        finalData = _.merge(finalData, response.data.data)
        localStorage.setItem('accessToken', finalData.accessToken)
        store.dispatch('login', { 'accessToken': finalData.accessToken, 'user': finalData.user })
        result(true, response.data.message)
      } else {
        console.error(response.data.code, response.data.message)
        result(false, response.data.message)
      }
    })
  } catch (err) {
    console.error('getToken', err)
    result(false, err)
  }
}

// 토큰 갱신
const refreshToken = async (result) => {
  let finalData = {
    accessToken: '',
    user: {
      id: '',
      name: ''
    }
  }

  const options = {
    method: 'GET',
    url: '/member/refresh-token',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }

  try {
    await axios(options).then((response) => {
      if (response.data.code === 100) {
        finalData = _.merge(finalData, response.data.data)
        localStorage.setItem('accessToken', finalData.accessToken)
        store.dispatch('login', { 'accessToken': finalData.accessToken, 'user': finalData.user })
        result(true, finalData.accessToken)
      } else {
        console.error(response.data.code, response.data.message)
        result(false, null)
      }
    })
  } catch (err) {
    console.error('refeshToken', err)
    result(false, err)
  }
}

export default {
  getToken,
  refreshToken,
}
